import "./send-to-kindle-preview.css";

import { Controller } from "./controller";
import { View } from "./view";
import { ExtensionService } from "./extensionService";

class Preview {
    constructor() {
        this.view = new View();
        this.extensionService = new ExtensionService();
        this.controller = new Controller(this.view, this.extensionService);
    }

    async load() {
        await this.controller.load();
    }
}

window.onload = async () => {
    const app = new Preview();
    await app.load();
};
